import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";
import { AI_INSPIRATION_DISCLAIMER } from "@/lib/disclaimers";

/**
 * AI-for-inspiration disclaimer (PLA2-338).
 *
 * One reusable component shown across every consumer UI surface — the designer,
 * the generated design, checkout — so the "AI is for inspiration, real plants
 * vary" message is consistent everywhere. The email surface isn't React (template
 * lives in the Plantista repo), so it reuses the same copy via the
 * `AI_INSPIRATION_DISCLAIMER` constant in `@/lib/disclaimers`.
 */
export { AI_INSPIRATION_DISCLAIMER };

export function AiInspirationDisclaimer({
  variant = "inline",
  className,
}: {
  /** "inline" — minimal text row; "card" — bordered callout. */
  variant?: "inline" | "card";
  className?: string;
}) {
  return (
    <p
      className={cn(
        "flex items-center justify-center gap-1.5 text-center text-xs text-plantista-500 dark:text-plantista-400",
        variant === "card" &&
          "rounded-lg border border-plantista-200 bg-plantista-50/60 px-3 py-2 dark:border-plantista-800 dark:bg-plantista-900/40",
        className
      )}
    >
      <Sparkles className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span>{AI_INSPIRATION_DISCLAIMER}</span>
    </p>
  );
}
